import { cn, formatNumber } from "@/lib";
import React from "react";
import { IMilitaryInquiryItem } from "@/interfaces";

interface IRadioProps {
  selectedInquiry: any;
  setSelectedInquiry: (service: any) => void;
  setSampleService: (service: any) => void;
  services: IMilitaryInquiryItem[];
}

const MilitaryServices = ({
  selectedInquiry,
  setSelectedInquiry,
  services,
  setSampleService,
}: IRadioProps) => {
  return (
    <>
      {services.map((item) => (
        <label
          key={item.id}
          className={cn(
            "relative mb-3 block",
            selectedInquiry.status === "active" && "cursor-pointer",
          )}
          htmlFor={`military-service-${item.id}`}
          aria-expanded={selectedInquiry?.id === item.id}
        >
          <input
            id={`military-service-${item.id}`}
            type="radio"
            name="service-selection"
            value={item.id}
            checked={selectedInquiry?.id === item.id}
            onChange={() => setSelectedInquiry(item)}
            className="sr-only"
            disabled={item.status !== "active"}
          />
          {selectedInquiry.status === "active" && (
            <div
              onClick={(e) => {
                e.stopPropagation();
                setSelectedInquiry(item);
              }}
              className={cn(
                "border-primary-main bg-main-body absolute top-2 left-2 flex h-[20px] w-[20px] items-center justify-center rounded-full border-2 transition-colors duration-300 lg:h-[26px] lg:w-[26px]",
                item.status !== "active" &&
                  "pointer-events-none cursor-not-allowed border-gray-300 bg-gray-200 opacity-60",
              )}
            >
              <div
                className={cn(
                  "rounded-full transition-transform duration-300",
                  selectedInquiry?.id === item.id
                    ? "bg-primary-main h-[12px] w-[12px] scale-100 lg:h-[16px] lg:w-[16px]"
                    : "scale-0",
                )}
              />
            </div>
          )}
          <div className="bg-main-body items-cente flex gap-2 overflow-hidden rounded-[10px] border border-gray-200 p-3">
            <div
              className={cn(
                "flex h-full! max-h-[70px] w-full! max-w-[70px] items-center justify-center",
                item.status !== "active"
                  ? "text-gray-400"
                  : "text-primary-main",
              )}
            >
              {item.icon}
            </div>
            <div className="flex flex-col justify-center">
              <h1
                className={cn(
                  "text-base font-bold lg:text-lg",
                  item.status !== "active" ? "text-gray-400" : "",
                )}
              >
                {item.name}
              </h1>
              <p
                className={cn(
                  "mt-1 pl-3 text-sm",
                  item.status !== "active" ? "text-gray-400" : "text-gray-700",
                )}
              >
                {item.description}
              </p>
              <div className={cn("mt-2 flex items-center justify-between")}>
                {/*<div>*/}
                {/*  <CustomButton*/}
                {/*    id="military-service-status-sample"*/}
                {/*    type="button"*/}
                {/*    disabled={item.status !== "active"}*/}
                {/*    className="border-primary-main text-primary-main hover:bg-primary-main/5 max-w-[130px] border bg-transparent !px-3 !py-1 !text-sm"*/}
                {/*    onClick={(e) => {*/}
                {/*      e.preventDefault();*/}
                {/*      e.stopPropagation();*/}
                {/*      setSampleService(item);*/}
                {/*    }}*/}
                {/*  >*/}
                {/*    نمونه استعلام*/}
                {/*  </CustomButton>*/}
                {/*</div>*/}
                <div
                  className={cn(
                    "flex items-center",
                    item.status !== "active" ? "text-gray-400" : "text-red-700",
                  )}
                >
                  <p className="text-lg font-bold">
                    {formatNumber(item.price)}
                  </p>
                  <span className="text-sm font-bold">ت</span>
                </div>
              </div>
            </div>
          </div>
        </label>
      ))}
    </>
  );
};

export default MilitaryServices;
